import React, { useEffect, useState } from 'react';

const ResponsiveImage = ({
  src,
  thumbnail,
  avif,
  thumbnailAvif,
  alt,
  width,
  height,
  className = '',
  loading = 'lazy',
  priority = false,
  ...props
}) => {
  const [fallbackSrc, setFallbackSrc] = useState(null);
  useEffect(() => setFallbackSrc(null), [src, thumbnail]);
  const isWebp = (value) => /\.webp(?:[?#]|$)/i.test(String(value || ''));
  const loadingStrategy = priority ? 'eager' : loading;
  const fetchPriority = priority ? 'high' : 'auto';
  const altText = alt || 'Yemen Heritage image';

  if (!src && !thumbnail) return null;

  const fallback = fallbackSrc || src || thumbnail;
  const handleError = () => {
    if (thumbnail && fallback !== thumbnail) setFallbackSrc(thumbnail);
  };
  const imgProps = {
    alt: altText,
    loading: loadingStrategy,
    fetchPriority,
    decoding: 'async',
    className,
    width,
    height,
    ...props,
    onError: handleError,
  };

  if (src && thumbnail) {
    return (
      <picture>
        {/* AVIF mobile */}
        {thumbnailAvif && (
          <source type="image/avif" media="(max-width: 768px)" srcSet={thumbnailAvif} />
        )}
        {/* AVIF desktop */}
        {avif && (
          <source type="image/avif" media="(min-width: 769px)" srcSet={avif} />
        )}
        {/* WebP mobile */}
        <source {...(isWebp(thumbnail) ? { type: 'image/webp' } : {})} media="(max-width: 768px)" srcSet={thumbnail} />
        {/* WebP desktop */}
        <source {...(isWebp(src) ? { type: 'image/webp' } : {})} media="(min-width: 769px)" srcSet={src} />
        <img src={fallback} {...imgProps} />
      </picture>
    );
  }

  // Single source path (no thumbnail)
  const singleSrc = src || thumbnail;
  const singleAvif = avif || thumbnailAvif;

  if (singleAvif) {
    return (
      <picture>
        <source type="image/avif" srcSet={singleAvif} />
        <source {...(isWebp(singleSrc) ? { type: 'image/webp' } : {})} srcSet={singleSrc} />
        <img src={fallback} {...imgProps} />
      </picture>
    );
  }

  return <img src={fallback} {...imgProps} />;
};

export default ResponsiveImage;
